import React, { useState, useEffect } from "react";
import Search from "../assets/icons/Search";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import rest1 from "../assets/images/rest1.webp";
import rest2 from "../assets/images/rest2.webp";
import rest3 from "../assets/images/rest3.webp";
import rest4 from "../assets/images/rest4.webp";
import RestaurantListCard from "../components/RestaurantListCard";
import { get, post, postWithImage } from "../network/api";
import { useSearchParams } from "react-router-dom";

// Updated category data for Swiper
const categoryMenu = [
  
];



const AllRestaurants = () => {
  const [searchParams] = useSearchParams();
  const queryHome = searchParams.get("query") || ""; 
  const [query, setQuery] = useState(queryHome);

  const [listings, setListings] = useState([]); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);  
  const [lat, setLat] = useState(null);
  const [long, setLong] = useState(null);
  const [currentDate, setCurrentDate] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  

  useEffect(  () => {
      getRestaurants();
  }, []); 

  async function getRestaurants() { 
    const now = new Date();
    setCurrentDate(now.toLocaleDateString());
    setCurrentTime(now.toLocaleTimeString());
    // Get current location
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLat(position.coords.latitude);
                setLong(position.coords.longitude);
            },
            (error) => {
                console.error('Error getting location:', error);
            }
        );
    } else {
        console.error('Geolocation is not supported by this browser.');
    }
    const requestData = {
      lat,
      long,
      date: currentDate,
      time: currentTime,
      "query":query
    };
    
    try {
      const data = await post('customer/restaurants',
        {
          "lat":12.9716,
          "long":77.5946,
          "day":"Monday",
          "time":"11:30",
          "query":query
      }
      )
      setListings(data);
      setLoading(false);
    }
    catch (e) { 
        // setError(error.message); // Handle any errors
        setLoading(false);
    }
  }
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      getRestaurants();
    }
};
  

  return (
    <React.Fragment>
      <section className="restaurant_title bg-custom">
        <div className="wrapper">
          <div className="rest_menu_heading">
            <h2 className="subtitle_common">
              Restaurants in <span className="text-primary">Riga</span>
            </h2>
            <div className="cta_input">
              <div className="input_full">
                <input
                  type="text"
                  className="input_cta"
                  name="search"
                  id="search"
                  placeholder="Search food or restaurant here"
                  onChange={(e) => setQuery(e.target.value)}
                  value={query}
                  onKeyDown={handleKeyDown} 
                />
                <button className="btn btn-primary" onClick={getRestaurants} >
                  <Search /> <span>Search</span>
                </button>
              </div>
            </div>

            <div className="category_menu_slider">
              <Swiper
                spaceBetween={20}
                slidesPerView={9}
                autoplay={{ delay: 3000 }}
                navigation={true}
                loop={true}
                modules={[Navigation, Autoplay]}
                breakpoints={{
                  320: {
                    slidesPerView: 2,
                  },
                  576: {
                    slidesPerView: 4,
                  },
                  1024: {
                    slidesPerView: 6,
                  },
                  1200: {
                    slidesPerView: 9,
                  },
                }}
              >
                {categoryMenu.map((category, index) => (
                  <SwiperSlide key={index}>
                    <div className="category_item">
                      <p>{category}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="wrapper">
          <div className="item_list_grid">
            {listings.map((restaurant, index) => (
              <RestaurantListCard key={index} props={restaurant} />
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AllRestaurants;
